import { ALLOWED_ORIGINS } from '../constants'

export const isAllowedOrigin = (origin: string) => {
  let parsedOrigin
  try {
    const url = new URL(origin)
    parsedOrigin = url.origin
  } catch (error) {
    return false
  }
  return parsedOrigin && ALLOWED_ORIGINS.includes(parsedOrigin)
}
